document.addEventListener('DOMContentLoaded', function () {
  // Solo aplica en mobile
  var mobileMenu = document.getElementById('mobile-menu');
  if (!mobileMenu) return;

  // Cierra todos los submenús
  function closeAllSubmenus() {
    mobileMenu.querySelectorAll('.menu-item-has-children.open').forEach(function (item) {
      item.classList.remove('open');
    });
  }

  // Maneja el clic en los ítems con submenú
  mobileMenu.querySelectorAll('.menu-item-has-children > a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var parentLi = link.parentElement;
      var isOpen = parentLi.classList.contains('open');
      // Siempre prevenir navegación en mobile
      e.preventDefault();
      if (!isOpen) {
        closeAllSubmenus();
        parentLi.classList.add('open');
      } else {
        parentLi.classList.remove('open');
      }
    });
  });

  // Opcional: cerrar submenús al hacer clic fuera
  document.addEventListener('click', function (e) {
    if (!mobileMenu.contains(e.target)) {
      closeAllSubmenus();
    }
  });
}); 